import React from 'react'
import { useNavigate, useParams } from '@tanstack/react-router'
import { Card, ButtonGroup, ButtonToolbar, Col, Dropdown, Form, Row, ToggleButton, ListGroup } from 'react-bootstrap'
import { DeepRequired, FieldError, FieldErrors, FieldErrorsImpl, FieldPath, FieldValues, GlobalError, Merge } from 'react-hook-form'
import * as Icon from 'react-feather'

import { useCoreData } from '@/queries.ts'
import { CoreDataModel } from '@/models.ts'
import { UserOrg } from '@/models/user.tsx'

export function TextBox({ ...props }) {
    return (
        <input className="form-control" type="text" {...props} />
    );
}

export function DropDownList(props) {
    var filteredProps = Object.keys(props).filter(function (k) {
        return k.indexOf('capsdac_') != 0;
    }).reduce(function (newData, k) {
        newData[k] = props[k];
        return newData;
    }, {});
    return (
        <select className="form-select" {...filteredProps}>
            {props.capsdac_options?.map((x) => (
                <option value={x.value}>{x.text}</option>
            ))}
        </select>
    );
}

export function RadioList(props) {
    var filteredProps = Object.keys(props).filter(function (k) {
        return k.indexOf('capsdac_') != 0;
    }).reduce(function (newData, k) {
        newData[k] = props[k];
        return newData;
    }, {});
    return props.capsdac_options?.map(x => (
        <Form.Check type="radio" inline label={x.text} id={`${props.name}${x.value}` } value={x.value} checked={props.capsdac_initial_value === x.value} {...filteredProps} />
    ));
}

export function DetailCard({ items }: { items: { name: string, value: string }[] }) {
    return (
        <Card>
            <ListGroup>
                {items.map((x) => (
                    <ListGroup.Item>
                        {x.name} <span style={{ fontWeight: 'bold' }}>{x.value}</span>
                    </ListGroup.Item>
                ))}
            </ListGroup>
        </Card>
    )
}

export function formFieldRowsFn<T extends FieldValues = FieldValues>(errors: FieldErrors<T>) {
    return (name: Extract<keyof T, string>, labelText: string, inputFn: (name: Extract<keyof T, string>) => React.JSX.Element, tooltip?: string) => {
        const fieldError = errors[name] as FieldError
        return formFieldRowInternal(name, labelText, fieldError, inputFn, tooltip)
    }
}

function formFieldRowInternal<T extends string = string>(name: T, labelText: string, fieldError: FieldError | undefined, inputFn: (name: T) => React.JSX.Element, tooltip?: string) {
    return (
        <Row className="form-group row">
            <Col lg={4} className="text-lg-end">
                <label htmlFor={name} className="col-form-label">{labelText}</label>
                {tooltip &&
                    <span tabIndex={0} data-bs-toggle="tooltip" data-bs-placement="top" title={tooltip}>
                        <i className="fa fa-question-circle"></i>
                    </span>
                }
            </Col>
            <Col lg={6}>
                {inputFn(name)}
                {fieldError && <p role="alert">{fieldError.message}</p>}
            </Col>
        </Row>
    )
}

export function formInputRow(name: string, labelText: string, inputFn: (name: string) => React.JSX.Element, tooltip?: string) {
    return formFieldRowInternal(name, labelText, undefined, inputFn, tooltip)
}

export function codeSetData<ResultType>(accessorFn: (param: CoreDataModel) => ResultType) {
    var result = useCoreData()
    return accessorFn(result)
}

export function CodeSetList(props) {
    var result = useCoreData()
    return (
        <DropDownList id={props.id} capsdac_options={result[props.capsdac_codeset]} {...props} />
    );
}

//export function StopRouting({ children }) {
//    return (
//        <div onClick={(e) => { e.stopImmediatePropagation() } }>
//            {children}
//        </div>
//    )
//}

export function DownloadBlob(blob: Blob, filename: string) {
    const link = document.createElement("a")
    link.href = URL.createObjectURL(blob)
    link.download = filename
    // preact-iso does not play well blob urls since it attempts to put them on the history stack which fails
    link.onclick = (e) => e.stopImmediatePropagation()
    document.body.appendChild(link)
    link.click()
    window.URL.revokeObjectURL(link.href)
    link.remove()
}

export function NavTabs({ tabs }: { tabs: string[] }) {
    const params = useParams({ strict: false })
    const navigate = useNavigate()
    return (
        <ButtonGroup>
            {tabs.map((x: string, i: number) => (
                <ToggleButton variant="secondary" id={`nav-${i.toString()}`} value={i.toString()} type="radio" onClick={() => navigate({ to: '/$leaid/records/$tab', params: { leaid: params?.leaid, tab: x }}) }>
                    {`${x}`}
                </ToggleButton>
            ))}
        </ButtonGroup>
    );
}

export function redirectHome() {
    const navigate = useNavigate()
    navigate({ to: '/home' })
}


